import React from 'react';
import { IconProps } from '@keplerco/core';

export function RatingAssessmentEmptyStateImage({ size = 120 }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M30.5 59C46.7924 59 60 45.7924 60 29.5C60 13.2076 46.7924 0 30.5 0C14.2076 0 1 13.2076 1 29.5C1 45.7924 14.2076 59 30.5 59Z" fill="var(--borders_1)" />
      <path
        d="M36.8247 54.0682C36.8247 54.0682 36.2272 43.7895 37.4104 41.5417C38.5935 39.2939 42.6932 38.2861 42.6932 38.2861L46.072 32.5196C46.5581 31.6921 47.5302 31.2369 48.4574 31.4858C49.2967 31.7087 49.9819 32.4627 49.3773 34.5825C49.3773 34.5825 47.1343 39.5523 46.5226 40.598"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.1454 31.8082L48.996 22.8904C48.996 22.8904 49.2236 20.9177 52.1804 20.7802L53.7098 34.4851L50.1176 43.9553C50.1176 43.9553 43.7583 46.1225 44.1566 49.94C44.287 51.1967 44.4364 52.6549 44.5763 54.0254"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M33.3541 59L33.3398 54.0894L47.7182 54.0468L47.7324 58.9573" stroke="var(--baby-blue)" strokeWidth="0.948441" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M23.1753 54.0682C23.1753 54.0682 23.7728 43.7895 22.5896 41.5417C21.4064 39.2939 17.3068 38.2861 17.3068 38.2861L13.928 32.5196C13.4419 31.6921 12.4698 31.2369 11.5427 31.4858C10.7033 31.7087 10.018 32.4627 10.6226 34.5825C10.6226 34.5825 12.8657 39.5523 13.4775 40.598"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8554 31.8082L11.0048 22.8904C11.0048 22.8904 10.7772 20.9177 7.82042 20.7802L6.29102 34.4851L9.88327 43.9553C9.88327 43.9553 16.2425 46.1225 15.8442 49.94C15.7138 51.1967 15.5644 52.6549 15.4245 54.0254"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M26.646 59L26.6602 54.0894L12.2818 54.0468L12.2676 58.9573" stroke="var(--baby-blue)" strokeWidth="0.948441" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M33.2016 22.6019C34.9693 20.8343 34.9693 17.9683 33.2016 16.2006C31.4339 14.4329 28.5679 14.4329 26.8003 16.2006C25.0326 17.9683 25.0326 20.8342 26.8003 22.6019C28.568 24.3696 31.4339 24.3696 33.2016 22.6019Z"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22.0176 34.3121C22.0176 29.9066 25.5908 26.3334 29.9987 26.3334C32.2038 26.3334 34.1979 27.2273 35.6419 28.6713C37.0859 30.1153 37.9799 32.1117 37.9799 34.3145" stroke="var(--headings)" strokeWidth="0.948441" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M22.4799 20.6611C23.7865 19.3546 23.7865 17.2362 22.48 15.9297C21.1734 14.6231 19.0551 14.6232 17.7485 15.9297C16.442 17.2363 16.442 19.3546 17.7485 20.6611C19.0551 21.9677 21.1734 21.9677 22.4799 20.6611Z"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.2148 29.3159C14.2148 26.058 16.8539 23.4189 20.1141 23.4189C21.2712 23.4189 22.3548 23.7533 23.263 24.3318" stroke="var(--headings)" strokeWidth="0.948441" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M43.1148 19.0514C43.5393 17.253 42.4255 15.4512 40.6272 15.0267C38.8289 14.6023 37.027 15.716 36.6025 17.5143C36.1781 19.3126 37.2918 21.1146 39.0901 21.539C40.8885 21.9635 42.6904 20.8497 43.1148 19.0514Z"
        stroke="var(--headings)"
        strokeWidth="0.948441"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M36.7324 24.3352C37.6429 23.7543 38.7242 23.4199 39.886 23.4199C41.5149 23.4199 42.9921 24.0791 44.0567 25.1461C45.1237 26.2131 45.7877 27.6879 45.7877 29.3169" stroke="var(--headings)" strokeWidth="0.948441" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
